import React, { Suspense, useEffect, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import { LinearProgress, AppBar, Toolbar, Container, Typography, Hidden, Modal, Fade, Backdrop, Chip, IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '../components/atoms';
import logo from '../assets/img/logo.png';
import { Link } from 'react-router-dom';
import { logout } from '../utils/logout';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import colors from '../utils/colors';
import { useHistory, useLocation } from 'react-router';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    borderRadius: '0px',
    height: '100%',
    overflow: 'hide ',
    width: '100%',
    position: 'relative'
  },
  appBar: {
    backgroundColor: '#FFF',
    height: '70px',
    justifyContent: 'center',
    boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.1)'
  },
  img: {
    height: '50px',
    borderRadius: '8px'
  },
  link: {
    textDecoration: 'none'
  },
}));

const DashboardLayout = props => {

  const { route } = props;
  const classes = useStyles();
  const [openModalMenu, setOpenModalMenu] = useState(false);

  const optionsMenu = [
    {
      url: '/dashboard',
      label: 'Dash',
      new: false
    },
    {
      url: '/users',
      label: 'Usuários',
      new: false
    },
    {
      url: '/payments',
      label: 'Pagamentos',
      new: false
    },
    {
      url: '/proposals',
      label: 'Propostas',
      new: false
    }
  ]

  const history = useHistory();
  const location = useLocation();

  const handleRedirect = (url) => {
    setOpenModalMenu(false); // Primeiro, fecha o modal
    setTimeout(() => {
      history.push(url); // Depois de um pequeno delay, redireciona
    }, 300); // Pequeno delay para evitar glitches visuais
  };
  
  useEffect(() => {
    setOpenModalMenu(false); // Fecha o modal automaticamente ao mudar de rota
  }, [location.pathname]);

  return (
    <>

      <Suspense fallback={
        <div>
          <LinearProgress />
        </div>
      }>

        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            <Link to="/dashboard" className={classes.link}>
              <img src={logo} alt="Gryb" className={classes.img} />
            </Link>
            <Hidden only={['md', 'lg', 'xl']}>  
              <Typography style={{ flexGrow: 1 }} />
              <MenuRoundedIcon onClick={() => {setOpenModalMenu(true)}} style={{ color: 'black', paddingLeft: '20px', alignItems: 'center' }} />
            </Hidden>
            <Hidden only={['xs', 'sm']}>
              {optionsMenu.map((option) => (
                <>
                  <Link to={option.url} className={classes.link}>
                    <Typography style={{ paddingLeft: '20px', color: window.location.pathname == option.url ? colors?.primary : 'rgb(38, 35, 56)' }}>{option.label}</Typography>
                  </Link>
                  {option.new && (
                    <Chip color="primary" label="Novo" size="small" style={{ marginLeft: '5px' }} />
                  )}
                </>
              ))}
              <Typography style={{ flexGrow: 1 }} />
              <Button onClick={logout} size="small" variant="outlined" color="primary" label="Sair" />
            </Hidden>
          </Toolbar>
        </AppBar>

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={openModalMenu}
          onClose={() => {setOpenModalMenu(false)}}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openModalMenu}>
            <div className={classes.paper}>
              <Tooltip title="Fechar">
                <IconButton onClick={() => {setOpenModalMenu(false)}} style={{ position: 'absolute', top: '30px', right: '15px' }}>
                  <CloseRoundedIcon />
                </IconButton>
              </Tooltip>
              <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div>
                  {optionsMenu.map((option, index) => (
                    <div key={index}>
                      <Typography 
                        variant="h5" 
                        style={{ color: window.location.pathname == option.url ? colors?.primary : 'rgb(38, 35, 56)', textAlign: 'center', cursor: 'pointer' }}
                        onClick={() => handleRedirect(option.url)}
                      >
                        {option.label}
                      </Typography>
                      <br />
                      </div>
                  ))}
                  <Button onClick={logout} size="small" variant="outlined" color="primary" label="Sair" />
                </div>
              </div>
            </div>
          </Fade>
        </Modal>

        <main>
          <Container style={{ marginTop: '90px' }}>
            {renderRoutes(route.routes)}
          </Container>
        </main>

      </Suspense>

    </>
  );
}

export default DashboardLayout;